import { render, staticRenderFns } from "./header-programa.vue?vue&type=template&id=0ca2cdfe&"
import script from "./header-programa.component.ts?vue&type=script&lang=ts&"
export * from "./header-programa.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports